import { useState } from 'react';
import { useLang } from '../context/LanguageContext';
import { useNewsData } from '../context/NewsDataContext';
import { pickTeEn } from '../utils/localizedContent.js';
import './SiteAnnouncement.css';

const DISMISS_KEY = 'rk-announce-dismiss';

export default function SiteAnnouncement() {
  const { lang } = useLang();
  const { homeFeed } = useNewsData();
  const ann = homeFeed.announcement;
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === ann?.text;
    } catch {
      return false;
    }
  });

  if (!ann?.active || dismissed) return null;

  const text = pickTeEn(lang, ann.textTe || ann.text, ann.text);
  if (!text?.trim()) return null;

  const dismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(DISMISS_KEY, ann.text);
    } catch {
      /* ignore */
    }
  };

  const style = ann.style === 'warn' ? 'site-ann--warn' : 'site-ann--info';

  return (
    <div className={`site-ann ${style}`} role="status" data-sub-free>
      <div className="site-ann__inner">
        <p className="site-ann__text">
          {ann.href ? (
            <a href={ann.href} target="_blank" rel="noreferrer">
              {text}
            </a>
          ) : (
            text
          )}
        </p>
        <button type="button" className="site-ann__close" onClick={dismiss} aria-label="Dismiss">
          ✕
        </button>
      </div>
    </div>
  );
}
